// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"689":"1ce32ad0","712":"97d87a82","724":"207afe8f"}[chunkId] + ".chunk.js";
};